document.addEventListener('DOMContentLoaded', function () {

  var sidebar  = document.getElementById('filter-sidebar');
  var overlay  = document.getElementById('filter-overlay');
  var closeBtn = document.getElementById('filter-sidebar-close');
  var resetBtn = document.getElementById('filter-reset');
  var applyBtn = document.getElementById('filter-apply');

  var minSlider = document.getElementById('filter-price-min');
  var maxSlider = document.getElementById('filter-price-max');
  var priceMax  = minSlider ? parseInt(minSlider.max) || 1000 : 1000;

  function openSidebar() {
    if (sidebar) sidebar.classList.add('active');
    if (overlay) overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  function closeSidebar() {
    if (sidebar) sidebar.classList.remove('active');
    if (overlay) overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  if (closeBtn) closeBtn.addEventListener('click', closeSidebar);
  if (overlay)  overlay.addEventListener('click', closeSidebar);

  // Accordion
  document.querySelectorAll('.filter-group__toggle').forEach(function (toggle) {
    toggle.addEventListener('click', function () {
      this.closest('.filter-group').classList.toggle('open');
    });
  });

  // Prijs slider
  var minInput = document.getElementById('filter-price-min-input');
  var maxInput = document.getElementById('filter-price-max-input');
  var fill     = document.getElementById('filter-price-fill');

  function updateFill() {
    if (!minSlider || !maxSlider || !fill) return;
    var lo = parseInt(minSlider.value);
    var hi = parseInt(maxSlider.value);
    fill.style.left  = (lo / priceMax * 100) + '%';
    fill.style.width = ((hi - lo) / priceMax * 100) + '%';
  }

  if (minSlider && maxSlider) {
    minSlider.addEventListener('input', function () {
      if (parseInt(this.value) > parseInt(maxSlider.value) - 1) this.value = parseInt(maxSlider.value) - 1;
      if (minInput) minInput.value = this.value;
      updateFill();
    });
    maxSlider.addEventListener('input', function () {
      if (parseInt(this.value) < parseInt(minSlider.value) + 1) this.value = parseInt(minSlider.value) + 1;
      if (maxInput) maxInput.value = this.value;
      updateFill();
    });
    if (minInput) {
      minInput.addEventListener('change', function () {
        var v = Math.max(0, Math.min(parseInt(this.value) || 0, parseInt(maxSlider.value) - 1));
        this.value = v; minSlider.value = v; updateFill();
      });
    }
    if (maxInput) {
      maxInput.addEventListener('change', function () {
        var v = Math.min(priceMax, Math.max(parseInt(this.value) || 0, parseInt(minSlider.value) + 1));
        this.value = v; maxSlider.value = v; updateFill();
      });
    }
    updateFill();
  }

  // Apply
  if (applyBtn) {
    applyBtn.addEventListener('click', function () {
      var params = new URLSearchParams();

      var sortSel = document.getElementById('fs-sort-select') || document.getElementById('SortBy');
      if (sortSel && sortSel.value) params.set('sort_by', sortSel.value);

      document.querySelectorAll('.filter-option:checked').forEach(function (input) {
        var paramName = input.dataset.paramName;
        var value     = input.dataset.filterValue;
        if (paramName && value) params.append(paramName, value);
      });

      if (minSlider && parseInt(minSlider.value) > 0) {
        var minParamName = minSlider.dataset.paramName || 'filter.v.price.gte';
        params.set(minParamName, parseInt(minSlider.value) * 100);
      }
      if (maxSlider && parseInt(maxSlider.value) < priceMax) {
        var maxParamName = maxSlider.dataset.paramName || 'filter.v.price.lte';
        params.set(maxParamName, parseInt(maxSlider.value) * 100);
      }

      window.location.href = window.location.pathname + (params.toString() ? '?' + params.toString() : '');
    });
  }

  // Reset
  if (resetBtn) {
    resetBtn.addEventListener('click', function () {
      window.location.href = window.location.pathname;
    });
  }

  // Bouw filterbalk
  function buildFilterBar() {
    if (document.getElementById('fs-filterbar')) return;

    var productGrid = document.getElementById('product-grid');
    if (!productGrid) return;

    var collectionDiv = productGrid.parentNode;
    if (!collectionDiv) return;

    var shopifySelect = document.getElementById('SortBy');
    var currentSort   = shopifySelect ? shopifySelect.value : '';
    var sortOptions   = shopifySelect ? Array.from(shopifySelect.options) : [];

    var countEl   = document.getElementById('ProductCountDesktop');
    var countText = countEl ? countEl.innerText.trim() : '';

    var bar = document.createElement('div');
    bar.className = 'fs-filterbar';
    bar.id = 'fs-filterbar';

    var left = document.createElement('div');
    left.className = 'fs-filterbar__left';

    var filterBtn = document.createElement('button');
    filterBtn.type = 'button';
    filterBtn.className = 'filter-all-btn';
    filterBtn.id = 'filter-all-btn';
    filterBtn.textContent = 'All Filters';
    filterBtn.addEventListener('click', openSidebar);
    left.appendChild(filterBtn);

    if (sortOptions.length > 0) {
      var sortWrap = document.createElement('div');
      sortWrap.className = 'fs-sort-wrap';

      var sortLabel = document.createElement('label');
      sortLabel.textContent = 'Sort by:';
      sortLabel.setAttribute('for', 'fs-sort-select');
      sortWrap.appendChild(sortLabel);

      var sortSelect = document.createElement('select');
      sortSelect.id = 'fs-sort-select';
      sortOptions.forEach(function (opt) {
        var o = document.createElement('option');
        o.value = opt.value;
        o.textContent = opt.textContent;
        if (opt.value === currentSort) o.selected = true;
        sortSelect.appendChild(o);
      });
      sortSelect.addEventListener('change', function () {
        var params = new URLSearchParams(window.location.search);
        params.set('sort_by', this.value);
        window.location.href = window.location.pathname + '?' + params.toString();
      });
      sortWrap.appendChild(sortSelect);
      left.appendChild(sortWrap);
    }

    bar.appendChild(left);

    var right = document.createElement('div');
    right.className = 'fs-filterbar__right';
    right.id = 'fs-product-count';
    right.textContent = countText;
    bar.appendChild(right);

    collectionDiv.insertBefore(bar, collectionDiv.firstChild);
  }

  buildFilterBar();

});
